import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { motion, AnimatePresence } from 'framer-motion';

import Crop75Icon from '@material-ui/icons/Crop75';

import PopupWrapper from '../../PopupWrapper';
import { NODES } from '../../../constants';

const popupAnimation = {
  initial: { opacity: 0, y: '80%' },
  animate: { opacity: 1, y: '100%' },
  exit: { opacity: 0, y: '80%' },
  transition: {
    ease: [0.18, 0.89, 0.39, 1.4],
    duration: 0.3,
  },
};

const BUTTON_LABEL = 'snippet-button-label';
const BUTTON_LINK = 'snippet-button-link';
const EVENT_NAME = 'snippet-button-event-name';

export const SnippetButton = ({ editor }) => {
  const [popupOpen, setPopupOpen] = useState(false);
  const [buttonLabel, setButtonLabel] = useState('');
  const [buttonLink, setButtonLink] = useState('');
  const [eventName, setEventName] = useState('');

  const handleAddButtonClick = () => {
    editor.insertInline({
      type: NODES.SNIPPET_BUTTON,
      data: { label: buttonLabel, href: buttonLink, eventName },
    });
    setPopupOpen(false);
  };

  return (
    <PopupWrapper
      isOpen={popupOpen}
      togglePopup={() => setPopupOpen(!popupOpen)}>
      <span className="icon__wrapper">
        <button
          title="Snippet Button"
          className="icon__button"
          onClick={() => setPopupOpen(!popupOpen)}>
          <Crop75Icon />
        </button>

        <AnimatePresence>
          {popupOpen && (
            <motion.div {...popupAnimation} className="icon__popup">
              <section className="flex items-center justify-between mb-6 text-sm whitespace-no-wrap">
                <label htmlFor={BUTTON_LABEL} className="font-bold">
                  Button Label
                </label>
                <input
                  type="text"
                  name={BUTTON_LABEL}
                  id={BUTTON_LABEL}
                  className="ml-3"
                  onChange={(event) => setButtonLabel(event.target.value)}
                />
              </section>

              <section className="flex items-center justify-between mb-6 text-sm whitespace-no-wrap">
                <label htmlFor={BUTTON_LINK} className="font-bold">
                  Button Link
                </label>
                <input
                  type="text"
                  name={BUTTON_LINK}
                  id={BUTTON_LINK}
                  className="ml-3"
                  onChange={(event) => setButtonLink(event.target.value)}
                />
              </section>

              <section className="flex items-center justify-between mb-6 text-sm whitespace-no-wrap">
                <label htmlFor={EVENT_NAME} className="font-bold">
                  Event Name (Optional)
                </label>
                <input
                  type="text"
                  name={EVENT_NAME}
                  id={EVENT_NAME}
                  className="ml-3"
                  onChange={(event) => setEventName(event.target.value)}
                />
              </section>

              <button
                className={cx(
                  'normal-button rounded p-1 font-bold cursor-pointer w-full',
                  { disable: !buttonLink || !buttonLabel }
                )}
                onClick={handleAddButtonClick}
                disabled={!buttonLink || !buttonLabel}>
                Add Snippet Button
              </button>
            </motion.div>
          )}
        </AnimatePresence>
      </span>
    </PopupWrapper>
  );
};

SnippetButton.propTypes = {
  editor: PropTypes.object,
  value: PropTypes.object,
};
